// ================== OpacityMotion Motion ==================
const getOpacity = () => ({ opacity: 0 });
const getRealOpacity = (node) => {
    return { opacity: 1 };
};
const getCurrentHeight = (node) => ({ opacity: 0 });
const skipOpacityTransition = (_, event) => event?.deadline === true || event.propertyName === 'opacity';
const OpacityMotion = {
    motionName: 'ant-motion-opacity',
    onAppearStart: getOpacity,
    onEnterStart: getOpacity,
    onAppearActive: getRealOpacity,
    onEnterActive: getRealOpacity,
    onLeaveStart: getCurrentHeight,
    onLeaveActive: getOpacity,
    onAppearEnd: skipOpacityTransition,
    onEnterEnd: skipOpacityTransition,
    onLeaveEnd: skipOpacityTransition,
    motionDeadline: 700
};
const getTransitionName = (rootPrefixCls, motion, transitionName) => {
    if (transitionName !== undefined) {
        return transitionName;
    }
    return `${rootPrefixCls}-${motion}`;
};
export { getTransitionName };
export default OpacityMotion;
